import { APP_CONFIGS, FORM_TYPE } from "../constants";
import { IRequest, IRequestError } from "../interfaces/authentication.interface";
import { IDSSForm, IFormValues } from "../interfaces/dss.interface";
import { request, strapiRequest } from "./requests.service";

export const getDSSForm = async (locale: string): Promise<IRequest<IDSSForm[] | IRequestError>> => {
    try {
        const query = `
            query DSSQuery($locale: I18NLocaleCode) {
                forms: dssForms(locale: $locale) {
                    formId
                    section
                    title
                    dimension                    
                    feedback_0
                    feedback_60
                    feedback_80
                    content_0
                    content_60
                    content_80
                }
            }`;

        const variables = {
            locale
        };

        const response = await strapiRequest.post<{ data: { forms: IDSSForm[] } }>(`/graphql`, {
            operationName: "DSSQuery",
            query,
            variables
        });

        return { success: true, data: response.data.data.forms.filter(f => f) ?? [] };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};

export const getDSSFormValues = async (): Promise<IRequest<IFormValues | IRequestError>> => {
    try {

        const response = await request.get<IFormValues>(`/${APP_CONFIGS.api.base}/dss/scores`);

        return { success: true, data: response.data ?? null };
    } catch (error: any) {
        return { success: false, data: error };
    }
};